import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageSecurity: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageSecurity"><Path d="M11.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V10.5M14.5 14.25V17.4199C14.5 19.6339 16.2708 20.4815 18 21.25C19.7292 20.4815 21.5 19.6339 21.5 17.4199V14.25C19.0769 12.8772 16.9231 12.8772 14.5 14.25Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageSecurity;
